import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import loyaltyPointsQuery from './query'
import { ILoyaltyPointsResponse, ILoyaltyPointsVariables } from './types'

/**
 * Lazy loyalty-points query hook (COM-1397).
 *
 * Mirrors `useLazyGetCart`: pins `fetchPolicy: 'no-cache'` and neutralises
 * `nextFetchPolicy` and `initialFetchPolicy` beside the pin, which
 * `fetchPolicyPins` enforces for every cart-adjacent query. The widget
 * needs the fresh number on every cart edit, so a cached hit would be
 * wrong.
 * @internal
 */
export const useLazyLoyaltyPoints = (
  options?: Omit<
    LazyQueryHookOptions<ILoyaltyPointsResponse, ILoyaltyPointsVariables>,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<ILoyaltyPointsResponse, ILoyaltyPointsVariables>(
    loyaltyPointsQuery,
    {
      ...options,
      fetchPolicy: 'no-cache',
      nextFetchPolicy: undefined,
      initialFetchPolicy: undefined,
    },
  )
}

export default useLazyLoyaltyPoints
